import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { cloneDeep } from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { successMessageToast } from "helpers/common";
import { MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST } from "config/paths";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { STATUS_OPTIONS, TEMPLATE_OPTIONS } from "config/constants";
import { CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import { useCreateTemplateMutation, useGetTemplateDetailQuery, useLazyGetHtmlTemplateQuery, useUpdateTemplateMutation, } from "store/services/notification";
import addTemplateSchema from "./addTemplate.schema";

const AddNotificationTemplate = () => {
  const { id: templateId } = useParams();
  const editMode = !!templateId;
  const navigate = useNavigate();

  const [notificationType, setNotificationType] = useState("");
  const [html, setHtml] = useState("");
  const [initialValues, setInitialValues] = useState({

    template_id: null,
    subject: "",
    template_desc: "",
    email_heading: "",
    email_content: "",
    email_status: STATUS_OPTIONS[0],
    firebase_status: "active",
    notification_type: ""
  });

  const [getHtmlTemplate, { isLoading: getTemplateLoading, isFetching: getTemplateFetching }] = useLazyGetHtmlTemplateQuery();
  const [updateTemplate, { isLoading: updateCmsLoading }] = useUpdateTemplateMutation();
  const [createTemplate, { isLoading: createCmsLoading }] = useCreateTemplateMutation();
  const { data: templateDetails, isLoading } = templateId ? useGetTemplateDetailQuery(templateId) : {};

  const handleSubmit = async (payload) => {
    try {
      const values = cloneDeep(payload);
      values.email_status = payload?.email_status?.value;
      values.notification_type = payload?.notification_type?.value || "";

      const result = editMode
        ? await updateTemplate({ data: values, templateId })
        : await createTemplate(values);
      if (result?.error) {
        console.error("Error create notification template", result.error);
        return;
      }

      successMessageToast(result?.data?.message);
      navigate(MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST);
    } catch (err) {
      console.error("Error create  notification template", err);
    }
  };

  const getTemplate = async () => {
    try {

      const result = await getHtmlTemplate(notificationType);
      if (!result?.error) setHtml(result?.data)

    } catch (err) { console.error("Error create  notification template", err); }
  };

  useEffect(() => {
    if (!templateId) return;

    if (templateDetails) {

      if (templateDetails?.template?.template_html) setHtml(templateDetails?.template)
      setNotificationType(templateDetails?.notification_type);
      setInitialValues({
        template_id: templateDetails?.template_id,
        subject: templateDetails?.subject || "",
        template_desc: templateDetails?.template_desc || "",
        email_heading: templateDetails?.email_heading || "",
        email_content: templateDetails?.email_content || "",
        email_status: STATUS_OPTIONS.find((x) => x.value == templateDetails?.email_status) || "",
        firebase_status: "active",
        notification_type: TEMPLATE_OPTIONS.find((x) => x.value == templateDetails?.notification_type) || ""
      });
    }
  }, [templateDetails]);

  useEffect(() => {
    if (notificationType) getTemplate();

  }, [notificationType]);

  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <div className="pageHead pb-3">
                    <h6 className="m-0 fw-bold themeBlue">
                      {editMode ? "Edit Template" : "Add New Template"}
                    </h6>
                  </div>
                </div>
              </div>
            </Col>
            {isLoading ? (
              <LoadingIndicator />
            ) : (
              <>
                <Row>
                  <Col lg="6" className="my-2  shadow-lg">
                    {
                      (getTemplateLoading || getTemplateFetching) && <LoadingIndicator></LoadingIndicator>
                    }
                    <Formik
                      initialValues={initialValues}
                      validationSchema={addTemplateSchema}
                      onSubmit={handleSubmit}
                      enableReinitialize
                    >
                      {({ handleSubmit, handleChange, values, errors }) => (
                        <Form onSubmit={handleSubmit}>
                          <div
                            className="py-3"
                            style={{ borderTop: "1px solid #41a2a84d" }}
                          >
                            <Row>
                              <Col md="12" sm="12" className="my-2">
                                <label
                                  htmlFor=""
                                  className="form-label themeBlue fw-bold mb-0 d-flex"
                                >
                                  Template
                                </label>
                                <CommonSelect
                                  name="notification_type"
                                  placeholder="Select Notification Type"
                                  className={`${styles.formControl}`}
                                  option={TEMPLATE_OPTIONS}
                                  handleChangeCustom={(e) => setNotificationType(e.value)}
                                />
                              </Col>
                              <Col md="12" sm="12" className="my-2">
                                <label
                                  htmlFor=""
                                  className="form-label themeBlue fw-bold mb-0 d-flex"
                                >
                                  Email Heading
                                </label>
                                <AppInputField
                                  name="email_heading"
                                  fieldType={"textarea"}
                                  style={{ minHeight: "80px" }}
                                  placeholder="Enter Heading"
                                  className={`${styles.formControl} form-control`}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setInitialValues({ ...values, email_heading: e.target.value })
                                  }}
                                />

                              </Col>
                              <Col md="12" sm="12" className="my-2">
                                <label
                                  htmlFor=""
                                  className="form-label themeBlue fw-bold mb-0 d-flex"
                                >
                                  Email Content
                                </label>
                                <AppInputField
                                  name="email_content"
                                  fieldType={"textarea"}
                                  style={{ minHeight: "80px" }}
                                  placeholder="Enter Email Content"
                                  className={`${styles.formControl} form-control`}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setInitialValues({ ...values, email_content: e.target.value })
                                  }}
                                />

                              </Col>
                              <Col md="12" sm="12" className="my-2">
                                <label
                                  htmlFor=""
                                  className="form-label themeBlue fw-bold mb-0 d-flex"
                                >
                                  Email Subject
                                </label>

                                <AppInputField
                                  type="text"
                                  name="subject"
                                  placeholder="Enter Title"
                                  className={`${styles.formControl} form-control`}
                                  maxLength={100}
                                />
                              </Col>
                              <Col md="12" sm="12" className="my-2">
                                <label
                                  htmlFor=""
                                  className="form-label themeBlue fw-bold mb-0 d-flex"
                                >
                                  Description
                                  <RequiredFieldAstrick />
                                </label>
                                <AppInputField
                                  type="text"
                                  fieldType={'textarea'}
                                  name="template_desc"
                                  placeholder="Enter Title"
                                  className={`${styles.formControl} form-control`}
                                  maxLength={500}
                                />
                              </Col>
                              <Col md="12" sm="12" className="my-2">
                                <label
                                  htmlFor=""
                                  className="form-label themeBlue fw-bold mb-0 d-flex"
                                >
                                  Email Status
                                  <RequiredFieldAstrick />
                                </label>
                                <CommonSelect
                                  name="email_status"
                                  placeholder="Select Email Status"
                                  className={`${styles.formControl} form-control`}
                                  option={STATUS_OPTIONS}
                                />
                              </Col>
                            </Row>
                          </div>
                          <Row className="mt-5 ">
                            <Col className="my-2" lg="12">
                              <div
                                className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                style={{ borderTop: "1px solid #41a2a84d" }}
                              >
                                <Button
                                  disabled={
                                    createCmsLoading || updateCmsLoading
                                  }
                                  type="submit"
                                  className="d-flex align-items-center justify-content-center commonBtn"
                                >
                                  {createCmsLoading || updateCmsLoading ? (
                                    <LoadingIndicator inline />
                                  ) : (
                                    "Save"
                                  )}
                                </Button>
                                <Button
                                  onClick={() => navigate(MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST)}
                                  type="button"
                                  className="d-flex align-items-center justify-content-center commonBtn"
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </Col>
                  <Col
                    lg="6"
                    className="my-2 "
                    dangerouslySetInnerHTML={{
                      __html: html?.template_html?.replace("{HEADING}", initialValues?.email_heading?.split("\n")[0] || "{HEADING}")
                        .replace("{SUB_HEADING}", initialValues?.email_heading?.split("\n")[1] || "{SUB_HEADING}")
                        .replace("{GREETING}", initialValues?.email_heading?.split("\n")[2] || "{GREETING}")
                        .replace("{CONTENT}", initialValues?.email_content || "{CONTENT}")
                        .replace(/\n\n/g, "<br></br>")

                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                  >
                  </Col>

                </Row>
              </>
            )}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddNotificationTemplate;
